module.exports = __webpack_public_path__ + "static/icon-144x144-55213be0ff8684fd4db58c50e3fc2c65.png";